type ReportedStatusBadgeProps = {
  reported: boolean;
};

const ReportedStatusBadge = ({ reported }: ReportedStatusBadgeProps) => (
  <span
    className={`cle-status-badge ${
      reported ? "cle-status-badge--reported" : "cle-status-badge--info"
    }`}
  >
    {reported ? "Indberettet" : "Ikke indberettet"}
  </span>
);

export default ReportedStatusBadge;
